angular.module('core')
  .service('edxTimeframeListService', [
    function () {
        // A service for constructing lists of timeframes.
        // Eventually want to move most of the timeframe list construction logic out
        // of the timeframe dropdown and into this service.
        //
        // The current building of timeframes is extremely difficult to debug, modify and test 
        // because it partially occurs in controllers and partially in the timeframe dropdown
        // as a side effect of watches on timeframes.list and years.list. Code can run in
        // different order depending on when the years list comes back from the highlights call
        // and when the timeframe dropdown directive is loaded on the page.

        // TODO: in next iteration, maybe make timeframe ids constants.

        var self = this;

        var TIMEFRAMES = {
          '7d': {
            id: '7d',
            name: 'Last 7 Days',
            by: 'day',
            active: false
          },
          '30d': {
            id: '30d',
            name: 'Last 30 Days',
            by: 'week',
            active: false
          }
        };

        /**
         * Build a list of timeframes for the given timefame ids.  Set the active
         * timeframe based on defaultTimeframeId
         */
        self.buildList = function (timeframeIds, defaultTimeframeId) {
          var timeframeList = _.map(timeframeIds, function (id) {
            var timeframe = TIMEFRAMES[id];
            if (!timeframe) {
              throw new Error('Invalid timeframe id: ' + id);
            }

            timeframe.active = id === defaultTimeframeId;
            return timeframe;
          });

          return timeframeList;
        };

        /**
         * Build an object that contains a list of timeframes and set
         * selected timeframe based on the defaultTimeframeId
         */
        self.buildTimeframes = function (timeframeIds, defaultTimeframeId) {
          var list = self.buildList(timeframeIds, defaultTimeframeId);
          var timeframes = {
            list: list
          };

          timeframes.selected = _.clone(_.find(list, function (timeframe) {
            return timeframe.active;
          }));

          return timeframes;
        };

    }]
  );